import { render, staticRenderFns } from "./DescriptionConfig.vue?vue&type=template&id=d10a6ad8&scoped=true"
import script from "./DescriptionConfig.vue?vue&type=script&lang=js"
export * from "./DescriptionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10a6ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d10a6ad8')) {
      api.createRecord('d10a6ad8', component.options)
    } else {
      api.reload('d10a6ad8', component.options)
    }
    module.hot.accept("./DescriptionConfig.vue?vue&type=template&id=d10a6ad8&scoped=true", function () {
      api.rerender('d10a6ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/DescriptionConfig.vue"
export default component.exports